import store from "./redux/store";
import {NotificationSubscription_add} from "../network/api/NotificationSubscription";
import {reloadOnceWithOverlay} from "./appBuild";

export default function swDev() {
    if (!('serviceWorker' in navigator)) {
        return;
    }

    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    function arrayBufferToUrlBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    function urlBase64ToUint8Array(base64String) {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    function askWaitingWorkerToActivate(worker) {
        if (!worker) return;
        worker.postMessage({ type: 'SKIP_WAITING' });
    }

    function trackInstallingWorker(registration) {
        const installing = registration.installing;
        if (!installing) return;

        installing.addEventListener('statechange', () => {
            // A new SW finished installing while an older one still controls the page
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                askWaitingWorkerToActivate(installing);
            }
        });
    }

    // Reload only when an existing controller is replaced (not on first SW install).
    let hadControllerAtStart = Boolean(navigator.serviceWorker.controller);
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!hadControllerAtStart) {
            hadControllerAtStart = true;
            return;
        }
        reloadOnceWithOverlay("در حال به‌روزرسانی…");
    });

    navigator.serviceWorker.register(swUrl).then(async (registration) => {
        registration.addEventListener('updatefound', () => {
            trackInstallingWorker(registration);
        });

        // If a waiting worker is already sitting from a previous visit, activate it
        if (registration.waiting && navigator.serviceWorker.controller) {
            askWaitingWorkerToActivate(registration.waiting);
        }

        // Check for updates on startup (and when the tab becomes visible again)
        registration.update().catch(() => {});
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                registration.update().catch(() => {});
            }
        });

        const {auth: { token }} = store.getState();
        if (token) {
            if (Notification.permission === "granted") {
                navigator.serviceWorker.ready.then(() => {
                    subscribeAndSendToServer(registration);
                });
            } else {
                console.log("Notification permission denied. 👎");
            }
        }

        async function subscribeAndSendToServer(registration) {
            const vapidPublicKey = "BCesZltGiWtG7RVkAl4qpoMigCmELNahwEyxQ5ivA-IcO93wF3-ERqA2ZqB2-UCYuDVZBiVYgotmaoYOdG9U6bw";
            const existingSubscription = await registration.pushManager.getSubscription();
            const storedEndpoint = localStorage.getItem('push_endpoint');
            const {auth: {user}} = store.getState();
            const storedUserId = localStorage.getItem('push_userId');

            if (existingSubscription && existingSubscription.endpoint === storedEndpoint && storedUserId === String(user?.Id)) {
                return;
            }

            if (existingSubscription) {
                await existingSubscription.unsubscribe();
            }

            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
            });

            const subscriptionToSend = {
                endpoint: subscription.endpoint,
                p256dh: arrayBufferToUrlBase64(subscription.getKey('p256dh')),
                auth: arrayBufferToUrlBase64(subscription.getKey('auth')),
                user: { Id: user?.Id },
                appName: "WEBAPP"
            };

            NotificationSubscription_add(subscriptionToSend).then(() => {
                localStorage.setItem('push_endpoint', subscription.endpoint);
                if (user?.Id) {
                    localStorage.setItem('push_userId', String(user.Id));
                }
            }).catch(e => {
                console.error("Push subscription send error:", e);
            });
        }
    }).catch((error) => {
        console.error("Service Worker registration failed 👎 : ", error);
    });
}
